'use client';
import { useEffect, useState } from 'react';
import { ChevronDown, Check } from 'react-feather';
import locations from '@/utils/locations';
import classes from './FilterComps.module.css';
import { useRouter, usePathname } from 'next/navigation';

const LocationFilter = (props) => {
	const { theLocation, uniqueLocations, geoLocation, clearHandler } = props;

	const router = useRouter();
	const pathname = usePathname();

	const locationParam =
		pathname.split('/').at(1) === 'location' ? pathname.split('/').at(2) : null;

	const [showLocations, setShowLocations] = useState();

	useEffect(() => {
		setShowLocations(window.innerWidth > 600 || theLocation ? true : false);
	}, [theLocation]);

	const locations2 = [{ id: 'LOC', area: 'Buy Local' }, ...locations];

	const showLocationHandler = () => {
		setShowLocations(!showLocations);
	};

	const clearLocationHandler = (e, loc) => {
		if (locationParam && loc) {
			clearHandler(e, 'setLocation', 'location');
		} else {
			router.push(`/collections`);
		}
	};

	useEffect(() => {
		let newParams = new URLSearchParams(window.location.search);
		let loc = newParams.get('location');
		if (loc) {
			let id = locations2.find((i) => i.id === loc);
			checkBoxHandler(id);
		}
	}, [geoLocation]);

	const checkBoxHandler = async (loc) => {
		let newParams = new URLSearchParams(window.location.search);

		if (!locationParam && loc && pathname !== '/location') {
			if (loc) {
				newParams.set('location', loc.id.toLowerCase());
			} else {
				newParams.delete('location');
			}
			router.push(pathname + '?' + newParams.toString());
		} else if ((locationParam && loc) || pathname === '/location') {
			router.push(`/location/${loc.id.toLowerCase()}`);
		}
	};

	let mergedLocations = locations.map((loc) => {
		const match = uniqueLocations?.find((uloc) => uloc.region === loc.id);
		return {
			...loc,
			count: match ? match.count : 0,
		};
	});

	mergedLocations.sort((a, b) => b.count - a.count);

	return (
		<>
			<div className={classes.desktop}>
				<div className={classes.dropDown}>
					<div onClick={showLocationHandler} className={classes.justifyBetween}>
						Location{' '}
						<ChevronDown
							size={13}
							className={showLocations ? classes.flip : classes.icon}
						/>
					</div>
					{showLocations && (
						<div className={classes.box}>
							<h6 className={classes.buyLocal}>
								Choose to buy local by filtering your search by location.
								It&apos;s cheaper for you, and better for the planet.
							</h6>

							{mergedLocations.map((loc, idx) => {
								const matchedLocation =
									loc.id == 'LOC' ||
									uniqueLocations?.find((i) => i.region === loc.id);
								return matchedLocation ? (
									<div
										key={idx}
										onClick={
											loc.id.toLowerCase() === theLocation
												? (e) => clearLocationHandler(e, loc)
												: () => checkBoxHandler(loc)
										}
										className={classes.checkBoxBox}
									>
										<div className={classes.selectionCheck}>
											<span className={classes.smallGap}>
												<div
													className={
														theLocation === loc.id.toLowerCase()
															? classes.checkActive
															: classes.check
													}
												>
													{theLocation === loc.id.toLocaleLowerCase() ? (
														<Check className={classes.checkMark} />
													) : (
														''
													)}
												</div>
												<h3 className={classes.underline}>{loc.area} </h3>
											</span>
											<span className={classes.count}>
												{loc.id !== 'LOC'
													? `(${matchedLocation.count.toLocaleString(
															undefined,
															{
																maximumFractionDigits: 2,
															}
													  )})`
													: ''}
											</span>
										</div>
									</div>
								) : (
									''
								);
							})}
						</div>
					)}
				</div>
			</div>
		</>
	);
};

export default LocationFilter;
